/* Al-Haq: size the language / country pickers (header, phone menu, footer) to their text so the
   arrow sits right next to the word (Safari / Firefox fallback; Chrome and
   Edge use CSS field-sizing instead). */
(function () {
  if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) return;
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  function fit() {
    var selects = document.querySelectorAll('.header .thb-localization-forms.inside-header select, .mobile-menu-drawer .thb-localization-forms select, .footer .thb-localization-forms select');
    selects.forEach(function (select) {
      var option = select.selectedOptions && select.selectedOptions[0];
      if (!option) return;
      var cs = window.getComputedStyle(select);
      ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var text = option.textContent.trim();
      if (cs.textTransform === 'uppercase') text = text.toUpperCase();
      var spacing = parseFloat(cs.letterSpacing) || 0;
      var width = ctx.measureText(text).width + spacing * text.length +
        (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + 2;
      select.style.setProperty('width', Math.ceil(width) + 'px', 'important');
    });
  }
  window.addEventListener('load', function () { setTimeout(fit, 50); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(fit, 50); });
})();

/* Al-Haq: on phones, the delivery / exchanges / reviews strip shows one item
   at a time and moves to the next every 4 seconds. Swiping still works; it
   pauses for 8 seconds after someone touches it. */
(function () {
  function start() {
    var strips = document.querySelectorAll('.text-with-icons .text-with-icons__inner');
    strips.forEach(function (strip) {
      var pausedUntil = 0;
      // Always open on the first item (delivery). While the page is still
      // loading, the browser can leave the strip parked on the middle item.
      function toStart() { strip.scrollTo({ left: 0, behavior: 'auto' }); }
      toStart();
      window.addEventListener('load', function () { setTimeout(toStart, 50); });
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        strip.addEventListener(ev, function () { pausedUntil = Date.now() + 8000; }, { passive: true });
      });
      setInterval(function () {
        if (window.innerWidth > 767 || Date.now() < pausedUntil || document.hidden) return;
        var w = strip.clientWidth;
        if (!w || strip.scrollWidth <= w + 2) return;
        var next = strip.scrollLeft + w;
        if (next > strip.scrollWidth - w + 2) next = 0;
        strip.scrollTo({ left: next, behavior: 'smooth' });
      }, 4000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Al-Haq: on collection pages, long intro / description text is cut to a few
   lines with a "Read more" link, so products appear higher up the screen.
   On the homepage the same is done for the "Al Haq - Luxury Thobes & Modest
   Fashion" text near the bottom. */
(function () {
  if (!document.body) return;
  var isCollection = /\btemplate-collection\b/.test(document.body.className);
  var isHome = /\btemplate-index\b/.test(document.body.className);
  if (!isCollection && !isHome) return;
  var css = document.createElement('style');
  css.textContent =
    '.alhaq-clamp{overflow:hidden;position:relative;margin-bottom:0 !important;transition:max-height .45s ease;' +
    '-webkit-mask-image:linear-gradient(to bottom,#000 55%,transparent);mask-image:linear-gradient(to bottom,#000 55%,transparent)}' +
    '.alhaq-clamp.is-open{-webkit-mask-image:none;mask-image:none}' +
    '.alhaq-readmore{display:inline-block;margin:6px auto 0;padding:4px 0;background:none;border:0;border-bottom:1px solid currentColor;' +
    'font-size:12px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;color:inherit;line-height:1.4}' +
    '.alhaq-readmore-wrap{text-align:center;margin:0 0 36px}';
  document.head.appendChild(css);

  var targets = document.querySelectorAll(isCollection
    ? '#main-content .collection-banner--description, #main-content .section-rich-text .rte'
    : '#main-content [id$="__rich_text_CRGkL8"] .rte');
  targets.forEach(function (el) {
    var lh = parseFloat(getComputedStyle(el).lineHeight) || 24;
    var lines = window.innerWidth < 768 ? 3 : 4;
    var closed = Math.round(lh * lines);
    if (el.scrollHeight < closed * 1.6) return; // short enough already
    // End the cut-off at the bottom of the last paragraph that fits, so there
    // is no empty space between the text and "Read more".
    var top = el.getBoundingClientRect().top, fit = 0;
    Array.prototype.forEach.call(el.children, function (c) {
      var b = c.getBoundingClientRect().bottom - top;
      if (b <= closed + 2) fit = Math.max(fit, b);
    });
    if (fit > lh * 1.5) closed = Math.ceil(fit);
    el.classList.add('alhaq-clamp');
    el.style.maxHeight = closed + 'px';
    var wrap = document.createElement('div');
    wrap.className = 'alhaq-readmore-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'alhaq-readmore';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    wrap.appendChild(btn);
    el.parentNode.insertBefore(wrap, el.nextSibling);
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      el.style.maxHeight = open ? el.scrollHeight + 'px' : closed + 'px';
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

/* Al-Haq: give screen-reader names to icon-only links and buttons
   (banner slide links and the video reel buttons). */
(function () {
  function label() {
    document.querySelectorAll('.slideshow__slide-content-link').forEach(function (a) {
      if (a.getAttribute('aria-label')) return;
      var slide = a.closest('.carousel__slide, .slideshow__slide') || a.parentElement;
      var h = slide && slide.querySelector('h1, h2, h3, .h1, .h2');
      a.setAttribute('aria-label', h ? h.textContent.replace(/\s+/g, ' ').trim() : 'View collection');
    });
    document.querySelectorAll('.shoppable-video-reels--button').forEach(function (b) {
      if (b.getAttribute('aria-label') || b.textContent.trim()) return;
      b.setAttribute('aria-label', b.classList.contains('video-controls--sound') ? 'Sound on or off' : 'Play or pause video');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label);
  else label();
})();

/* Al-Haq: hide filters that don't apply to a collection (e.g. "Age group" on
   men's pages, "Size" on shemaghs). Re-applied whenever the filters reload. */
(function () {
  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]).toLowerCase();
  var adult = ['Age group', 'Collection', 'Season'];
  var kids = ['Collection', 'Season'];
  var shemagh = ['Size', 'Collection', 'Age group', 'Season'];
  var rules = {
    'men-collection': adult, 'zibda-collection': adult, 'emirati-collection': adult,
    'premium-emirati-cotton-thobes': adult, 'signature-collection': adult,
    'moroccan-collection': adult, 'royal-hooded-djellabas': adult,
    'winter-hooded-moroccan-thobes': adult, 'luxury-djellaba': adult,
    'bahrani-collection': adult, 'butterfly-collection': adult,
    'hayaat-eid-abaya-collection': adult,
    'kids-moroccan-gandouras': kids, 'boys-omani-collection': kids,
    'toddler-thobes': kids, 'kids-emirati-zibda-thobes': kids,
    'boys-premium-hooded-djellabas': kids, 'boys-royal-lightweight-hooded-djellaba': kids,
    'shemagh-scarves': shemagh, 'yemeni-shemagh': shemagh,
    'egyptian-kufis': ['Collection', 'Age group', 'Season']
  };
  var hide = rules[handle];
  if (!hide) return;
  function apply() {
    document.querySelectorAll('summary.thb-filter-title').forEach(function (s) {
      var label = s.textContent.replace(/\s+/g, ' ').trim();
      if (hide.indexOf(label) === -1) return;
      var box = s.closest('details') || s.parentElement;
      if (box && box.style.display !== 'none') box.style.display = 'none';
    });
  }
  function start() {
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Al-Haq: collection Filter / Sort bar and filter panel.
   - The Sort button shows the current choice; "Most relevant" (a search-only
     option) is removed on collection pages.
   - The Filter button shows how many filters are switched on.
   - In the filter panel only Size and Colour start open (plus anything in use).
   Runs again whenever the theme reloads the filters. */
(function () {
  if (!/\/collections\//.test(location.pathname)) return;
  function apply() {
    // Sort options: keep Featured, Best selling and the two price options.
    // "Most relevant" is search-only; A-Z/Z-A and date ones aren't useful here.
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      ['most-relevant', 'title-ascending', 'title-descending', 'created-ascending', 'created-descending'].forEach(function (v) {
        var o = sel.querySelector('option[value="' + v + '"]');
        if (o && !o.selected) o.remove();
      });
    });
    document.querySelectorAll('.facets--bar .thb-filter-sort .select').forEach(function (box) {
      var sel = box.querySelector('select');
      if (!sel) return;
      var txt = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
      if (box.getAttribute('data-current') !== txt) box.setAttribute('data-current', txt);
      if (!sel.dataset.alhaq) {
        sel.dataset.alhaq = '1';
        sel.addEventListener('change', function () {
          box.setAttribute('data-current', sel.options[sel.selectedIndex].text);
        });
      }
    });
    var n = 0;
    document.querySelectorAll('.facets--bar .active-facets .active-facets__button:not(.active-facets__button-remove), .facets--bar .active-facets a.active-facets__button').forEach(function (a) {
      if (!/clear|remove all/i.test(a.textContent)) n++;
    });
    document.querySelectorAll('.facets--bar .facets-toggle').forEach(function (t) {
      t.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && /filter and sort/i.test(node.textContent)) node.textContent = ' Filter';
      });
      var badge = t.querySelector('.alhaq-filter-count');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'alhaq-filter-count'; t.appendChild(badge); }
        if (badge.textContent !== String(n)) badge.textContent = n;
      } else if (badge) badge.remove();
    });
    document.querySelectorAll('details.thb-filter.js-filter:not([data-alhaq])').forEach(function (d) {
      d.setAttribute('data-alhaq', '1');
      var label = (d.querySelector('summary') || d).textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var inUse = d.querySelector('input:checked');
      var keep = /^(size|colou?r)$/.test(label);
      if (!keep && !inUse && label !== 'availability') d.open = false;
    });
  }
  function start() {
    apply();
    new MutationObserver(function () { apply(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
